export const FETCH_SWING_USERS_REQUEST = "FETCH_SWING_USERS_REQUEST";
export const FETCH_SWING_USERS_SUCCESS = "FETCH_SWING_USERS_SUCCESS";
export const FETCH_SWING_USERS_FAILURE = "FETCH_SWING_USERS_FAILURE";
export const FETCH_SWING_TRIPS_REQUEST = "FETCH_SWING_TRIPS_REQUEST";
export const FETCH_SWING_TRIPS_SUCCESS = "FETCH_SWING_TRIPS_SUCCESS";
export const FETCH_SWING_TRIPS_FAILURE = "FETCH_SWING_TRIPS_FAILURE";

//
export const STATE_CLEAN = "STATE_CLEAN";
